// A watcher's stream view (issue 1040; COMM-009, COMM-010): a seat that watches holds a DM's invite and sees what a
// player who owns no tokens sees — so the view is the board and the turn order and nothing else: no bars, no menus,
// no properties, no dice bag, no tracker to edit. "Watching" in the top bar says why. Laid out for a stream: the board
// takes the window, the initiative strip runs along its foot.
import type { ReactNode } from 'react';
import type { TableView, UserSettings } from '@dragons-table/vtt-shared';
import type { TableResult } from '../table';
import { ShellContext, type ShellContextValue } from './context';
import { InitiativeStrip } from './panels/InitiativeStrip';

export interface StreamViewProps {
  campaignId: string;
  table: TableView;
  onResult: (r: TableResult) => void;
  board: ReactNode;
  settings: UserSettings;
  onSettings: (s: UserSettings) => void;
}

const nothing = () => {};

export function StreamView({ campaignId, table, onResult, board, settings, onSettings }: StreamViewProps) {
  const value: ShellContextValue = { view: 'main', campaignId, table, onResult, board, openAdd: nothing, demote: nothing, settings, onSettings };
  return (
    <ShellContext.Provider value={value}>
      <div className="flex h-screen w-screen flex-col bg-stone-950 text-stone-100" data-testid="stream-view">
        <header className="flex shrink-0 items-center gap-3 border-b border-stone-800 px-3 py-1.5 text-sm">
          <span className="truncate font-medium" data-testid="table-name">{table.name}</span>
          <span className="rounded bg-sky-900 px-2 py-0.5 text-xs font-medium text-sky-50" data-testid="watching-badge">Watching</span>
        </header>
        <main className="relative min-h-0 flex-1">{board}</main>
        <footer className="shrink-0 border-t border-stone-800 bg-stone-900" data-testid="stream-initiative">
          <InitiativeStrip />
        </footer>
      </div>
    </ShellContext.Provider>
  );
}
